const ORGANISATION_ID = (state, id) => {
  state.organisationId = id
}

const ORGANISATION = (state, data) => {
  state.organisation = data
}

export default {
  ORGANISATION_ID,
  ORGANISATION
}
